import React from 'react';
import { AppType, useAppType } from '../../hooks/useAppType';

export type AppTypeGuardProps = {
    children: React.ReactNode | (() => React.ReactNode);
};

const AppTypeGuardImpl: React.FC<AppTypeGuardProps & { appType: AppType }> = (props) => {
    const appType = useAppType();

    if (appType === props.appType) {
        if (typeof props.children === 'function') {
            return props.children();
        }
        return <>{props.children}</>;
    } else {
        return null;
    }
};

export const ConsumerAppGuard: React.FC<AppTypeGuardProps> = (props) => {
    return <AppTypeGuardImpl appType="consumer" {...props} />;
};

export const ProfessionalAppGuard: React.FC<AppTypeGuardProps> = (props) => {
    return <AppTypeGuardImpl appType="professional" {...props} />;
};
